import { createModuleActionCreators } from "core/utils";

import type { Credentials } from "../../types/fe/entities/credentials";
import type { Path } from "../types/routerTypes";
import { NAME } from "./constants";

const { createEmptyAction, createPayloadAction } = createModuleActionCreators(NAME);

export const authActions = {
    setUserName: createPayloadAction("SET_USER_NAME")<Readonly<string>>(),
    setAuthToken: createPayloadAction("SET_AUTH_TOKEN")<Readonly<Credentials>>(),
    redirect: createPayloadAction("REDIRECT")<Path>(),
    clearRedirect: createEmptyAction("CLEAR_REDIRECT"),
};
